<template>
	<div class="rc-container" :class="{actived:actived,warning:item.not_review_num && item.not_review_num !== '0'}">
		<div class="header flex">
			<div class="title">{{item.item_name}}
			</div>
			<div v-if="item.status == 4" class="end-review">
				项目已完结
			</div>
		</div>
		<div class="cell col-center">
			<div>所属项目：</div>
			<div>{{item.project_name}}</div>
		</div>
		<div class="cell col-center">
			<div>项目编号：</div>
			<div>{{item.number}}</div>
		</div>
		<div class="cell col-center">
			<div>项目开题时间：</div>
			<div v-if="item.date.approval_start_time || item.date.approval_end_time">
				{{(item.date.approval_start_time || '未设置')+' ~ '+(item.date.approval_end_time || '未设置')}}
			</div>
			<div v-else>未设置时间</div>
		</div>
		<div class="cell col-center">
			<div>项目中期时间：</div>
			<div v-if="item.date.metaphase_start_time || item.date.metaphase_end_time">
				{{(item.date.metaphase_start_time || '未设置')+' ~ '+(item.date.metaphase_end_time || '未设置')}}
			</div>
			<div v-else>未设置时间</div>
			<!-- <div>{{item.date.metaphase_start_time+' ~ '+item.date.metaphase_end_time}}</div> -->
		</div>
		<div class="cell col-center">
			<div>项目结题时间：</div>
			<div v-if="item.date.conclude_start_time || item.date.conclude_end_time">
				{{(item.date.conclude_start_time || '未设置')+' ~ '+(item.date.conclude_end_time || '未设置')}}
			</div>
			<div v-else>未设置时间</div>
			<!-- <div>{{item.date.conclude_start_time+' ~ '+item.date.conclude_end_time}}</div> -->
		</div>
		<div class="cell col-center">
			<div>项目过程状态：</div>
			<div class="primary">{{item.status_text}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		props: {
			item: {
				type: Object,
				default () {
					return {}
				}
			},
			actived: {
				type: Boolean,
				default: false
			}
		},
		components: {

		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.rc-container {
		padding: 0.625rem 1rem;
		border-radius: 0.25rem;
		background-color: #F7FAFE;
		border: 1px solid #DCE1E7;

		.new {
			color: white;
			background-color: #F34A4A;
			font-size: 0.875rem;
			padding: 0 0.25rem;
			margin-right: .5rem;
		}

		.title {
			font-size: 1.125rem;
			font-weight: bold;

			span {
				font-size: 1rem;
				font-weight: 530;
				color: #db0000;
				text-decoration: underline;
				cursor: pointer;
			}
		}

		.cell {
			color: #464646;
			margin-top: 0.625rem;

			.primary {
				color: #4389E0;
			}

			.success {
				color: #00CF13;
			}

			.silver {
				color: #999;
			}

			::v-deep {
				.el-statistic {
					width: auto;
					text-align: left;
				}
			}
		}

		.header {
			position: relative;
			align-items: flex-start;

			.new {
				margin-top: 4px;
			}
		}
	}

	.rc-container.actived {
		border: 1px solid #82B3F0;
		background-color: white;
		// box-shadow: 0.25rem 0.25rem 0.625rem rgba(0,0,0,.2);
	}

	.rc-container.warning {

		// border: 1px solid red;
		// background-color: white;
		// box-shadow: 0.25rem 0.25rem 0.625rem rgba(0,0,0,.2);
		.header {

			.title {}
		}

	}

	.end-review {
		position: absolute;
		z-index: 2;
		border-radius: 0.25rem;
		transform: rotate(45deg);
		padding: 0.375rem 0.625rem;
		right: -30px;
		top: 8px;
		border: 1px solid red;
		color: red;
	}

	.end-review.not {
		border: 1px solid rgba(192, 192, 192, .7);
		color: silver;
	}

	.end-review.ing {
		border: 1px solid #67C23A;
		color: #67C23A;
	}

	.end-review.about {
		border: 1px solid #E6A23C;
		color: #E6A23C;
	}
</style>